function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { darken } from "@mui/material/styles";
import { Gray100, Gray100Shadow, Primary100 } from "../fundations/effects/focusRing";
import { getBackgroundToken, getBorderToken, getButtonToken, getIconToken } from "../fundations/palette/colorTokens";
import { Corner8 } from "../fundations/shape/corners";
export const IconButton = {
    MuiIconButton: {
        defaultProps: {
            disableRipple: true,
            color: "ghostGray"
        },
        variants: [
            {
                props: {
                    size: "large"
                },
                style: ({ theme })=>({
                        padding: theme.spacing(1.5, 1.5),
                        svg: {
                            width: "24px",
                            height: "24px"
                        },
                        height: "48px",
                        width: "48px"
                    })
            },
            {
                props: {
                    size: "large",
                    edge: "start"
                },
                style: ({ theme })=>({
                        marginLeft: theme.spacing(-1.5)
                    })
            },
            {
                props: {
                    size: "large",
                    edge: "end"
                },
                style: ({ theme })=>({
                        marginRight: theme.spacing(-1.5)
                    })
            },
            {
                props: {
                    size: "medium"
                },
                style: ({ theme })=>({
                        padding: theme.spacing(1.5, 1.5),
                        height: "44px",
                        width: "44px"
                    })
            },
            {
                props: {
                    size: "medium",
                    edge: "start"
                },
                style: ({ theme })=>({
                        marginLeft: theme.spacing(-1.5)
                    })
            },
            {
                props: {
                    size: "medium",
                    edge: "end"
                },
                style: ({ theme })=>({
                        marginRight: theme.spacing(-1.5)
                    })
            },
            {
                props: {
                    size: "small"
                },
                style: ({ theme })=>_object_spread({
                        padding: theme.spacing(1.25, 1.25),
                        height: "40px",
                        width: "40px"
                    }, theme.typography.textSm)
            },
            {
                props: {
                    size: "small",
                    edge: "start"
                },
                style: ({ theme })=>({
                        marginLeft: theme.spacing(-1.25)
                    })
            },
            {
                props: {
                    size: "small",
                    edge: "end"
                },
                style: ({ theme })=>({
                        marginRight: theme.spacing(-1.25)
                    })
            },
            {
                props: {
                    size: "xsmall"
                },
                style: ({ theme })=>_object_spread({
                        padding: theme.spacing(1, 1),
                        height: "36px",
                        width: "36px"
                    }, theme.typography.textSm)
            },
            {
                props: {
                    size: "xsmall",
                    edge: "start"
                },
                style: ({ theme })=>({
                        marginLeft: theme.spacing(-1)
                    })
            },
            {
                props: {
                    size: "xsmall",
                    edge: "end"
                },
                style: ({ theme })=>({
                        marginRight: theme.spacing(-1)
                    })
            },
            {
                props: {
                    size: "2xsmall"
                },
                style: ({ theme })=>_object_spread({
                        padding: theme.spacing(0.75, 0.75),
                        height: "32px",
                        width: "32px"
                    }, theme.typography.textSm)
            },
            {
                props: {
                    size: "2xsmall",
                    edge: "start"
                },
                style: ({ theme })=>({
                        marginLeft: theme.spacing(-0.75)
                    })
            },
            {
                props: {
                    size: "2xsmall",
                    edge: "end"
                },
                style: ({ theme })=>({
                        marginRight: theme.spacing(-0.75)
                    })
            },
            {
                props: {
                    color: "primary"
                },
                style: ({ theme })=>({
                        // Adding a border to make sure button has same size as border buttons
                        border: `1px solid ${getButtonToken("buttonPrimary", theme)}`,
                        background: getButtonToken("buttonPrimary", theme),
                        color: getIconToken("iconOnColor", theme),
                        fill: getIconToken("iconOnColor", theme),
                        "&:hover": {
                            background: getButtonToken("buttonPrimaryHover", theme)
                        },
                        "&:focus": {
                            boxShadow: Primary100
                        },
                        "&:active": {
                            boxShadow: Primary100
                        },
                        "&:disabled": {
                            background: getButtonToken("buttonDisabled", theme)
                        }
                    })
            },
            {
                props: {
                    color: "secondary"
                },
                style: ({ theme })=>({
                        // Adding a border to make sure button has same size as border buttons
                        border: `1px solid ${getButtonToken("buttonSecondaryBorder", theme)}`,
                        background: getButtonToken("buttonSecondary", theme),
                        color: getIconToken("iconSecondary", theme),
                        fill: getIconToken("iconSecondary", theme),
                        "&:hover": {
                            background: getButtonToken("buttonSecondaryHover", theme)
                        },
                        "&:active": {
                            boxShadow: Gray100Shadow
                        },
                        "&:focus": {
                            boxShadow: Gray100Shadow
                        },
                        "&:disabled": {
                            borderColor: getBorderToken("borderDisabled", theme),
                            background: getBackgroundToken("backgroundSecondary", theme)
                        }
                    })
            },
            {
                props: {
                    color: "tertiary"
                },
                style: ({ theme })=>({
                        // Adding a border to make sure button has same size as border buttons
                        border: `1px solid ${getButtonToken("buttonTertiary", theme)}`,
                        background: getButtonToken("buttonTertiary", theme),
                        color: getIconToken("iconPrimary", theme),
                        fill: getIconToken("iconPrimary", theme),
                        "&:hover": {
                            background: getButtonToken("buttonTertiaryHover", theme)
                        },
                        "&:disabled": {
                            background: getButtonToken("buttonDisabled", theme)
                        },
                        "&:focus": {
                            boxShadow: Primary100
                        },
                        "&:active": {
                            boxShadow: Primary100
                        }
                    })
            },
            {
                props: {
                    color: "quarternary"
                },
                style: ({ theme })=>({
                        border: `1px solid ${getButtonToken("buttonQuarternaryBorder", theme)}`,
                        background: getButtonToken("buttonSecondary", theme),
                        color: getIconToken("iconPrimary", theme),
                        fill: getIconToken("iconPrimary", theme),
                        "&:hover": {
                            background: getButtonToken("buttonQuarternaryHover", theme)
                        },
                        "&:focus": {
                            boxShadow: Primary100
                        },
                        "&:active": {
                            boxShadow: Primary100
                        },
                        "&:disabled": {
                            background: "transparent",
                            borderColor: getBorderToken("borderDisabled", theme)
                        }
                    })
            },
            {
                props: {
                    color: "ghostGray"
                },
                style: ({ theme })=>({
                        border: `1px solid transparent`,
                        background: "transparent",
                        color: getIconToken("iconSecondary", theme),
                        fill: getIconToken("iconSecondary", theme),
                        "&:hover": {
                            background: getButtonToken("buttonGhostGrayHover", theme)
                        },
                        "&:focus": {
                            boxShadow: Primary100
                        },
                        "&:active": {
                            boxShadow: "none"
                        },
                        "&:disabled": {
                            background: "transparent",
                            borderColor: "transparent"
                        }
                    })
            },
            {
                props: {
                    color: "ghostPrimary"
                },
                style: ({ theme })=>({
                        border: `1px solid transparent`,
                        background: "transparent",
                        color: getIconToken("iconPrimary", theme),
                        fill: getIconToken("iconPrimary", theme),
                        "&:hover": {
                            background: getButtonToken("buttonGhostPrimaryHover", theme)
                        },
                        "&:focus": {
                            boxShadow: Primary100
                        },
                        "&:active": {
                            boxShadow: "none"
                        },
                        "&:disabled": {
                            background: "transparent",
                            borderColor: "transparent"
                        }
                    })
            }
        ],
        styleOverrides: {
            root: ({ theme })=>_object_spread_props(_object_spread({
                    textTransform: "none",
                    borderRadius: Corner8
                }, theme.typography.textMd), {
                    svg: {
                        width: "20px",
                        height: "20px"
                    },
                    "&:hover": {
                        ">.MuiAvatar-root": {
                            background: darken(getBackgroundToken("backgroundTertiary", theme), 0.05)
                        }
                    },
                    "&:disabled": {
                        borderColor: getButtonToken("buttonDisabled", theme),
                        color: getIconToken("iconDisabled", theme),
                        fill: getIconToken("iconDisabled", theme),
                        ">.MuiAvatar-root": {
                            opacity: 0.32
                        }
                    },
                    "&:focus": {
                        ">.MuiAvatar-root": {
                            boxShadow: Gray100
                        }
                    }
                })
        }
    }
};

//# sourceMappingURL=IconButton.js.map